import { classnames } from 'Utils/classnames/classnames.utils';
import { get } from 'lodash';
import { resolve } from 'redux-optimist-promise';
import {
  ADD_ACCOMMODATION,
  ADD_ACCOMMODATION_FROM_ALTERNATIVES,
  ADD_TRANSPORT,
  ADD_SERVICE,
  DELETE_SERVICE,
  DISPLAY_TOAST_ON_CONTEXT_SHARE,
  UPDATE_SERVICES,
  ADD_ACCOMMODATION_ERROR,
} from 'Store/booking/proposals/constants';
import { FETCH_ADDITIONAL_ACCOMMODATIONS } from 'Store/booking/additional-accommodations/additionalAccommodations.action';
import { FETCH_ADDITIONAL_TRANSPORTS } from 'Store/booking/additional-transports/additionalTransports.action';
import { UPDATE_BOOKING_CART } from 'Components/widgets/cart/cart.actions';
import { NEWSLETTER_SUBSCRIPTION_VALIDATION } from 'Components/widgets/popin-newsletter/PopinNewsletter';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { CLOSE_TOAST, OPEN_TOAST } from './toast.actions';
type State = {
  color: (typeof COLORS)[keyof typeof COLORS];
  icon: IconName;
  label: string;
  shouldDisplay: boolean;
};
const initialState = {
  color: COLORS.BLUE_WAVE,
  icon: ICONS.CHECK_OUTLINE,
  label: '',
  shouldDisplay: false,
};
export const toast = (state: State = initialState, action: Action<any>) => {
  switch (action.type) {
    case OPEN_TOAST:
    case resolve(ADD_ACCOMMODATION):
    case resolve(ADD_ACCOMMODATION_FROM_ALTERNATIVES):
    case resolve(ADD_TRANSPORT):
      return {
        className: classnames('mt-navigation', get(action, 'payload.className', '')),
        color: action.payload?.color || COLORS.BLUE_WAVE,
        icon: ICONS.CHECK_OUTLINE,
        label: get(action, 'payload.toastLabel') || get(action, 'meta.payload.toastLabel') || '',
        shouldDisplay: true,
        style: action.payload?.style,
      };

    case DISPLAY_TOAST_ON_CONTEXT_SHARE:
    case NEWSLETTER_SUBSCRIPTION_VALIDATION:
      return {
        className: 'mt-navigation',
        color: COLORS.BLUE_WAVE,
        icon: ICONS.CHECK_OUTLINE,
        label: get(action, 'payload.toastLabel') || get(action, 'meta.payload.toastLabel') || '',
        shouldDisplay: true,
      };

    case resolve(ADD_SERVICE):
    case resolve(UPDATE_SERVICES):
    case resolve(DELETE_SERVICE):
    case resolve(UPDATE_BOOKING_CART):
    case 'PICK_YOUR_ROOM_AGENCY_SUCCESS':
      return {
        className: 'mt-navigation',
        color: COLORS.BLUE_WAVE,
        icon: ICONS.CHECK_OUTLINE,
        label: get(action, 'payload.toastLabel') || get(action, 'meta.payload.toastLabel') || '',
        shouldDisplay: !!(
          get(action, 'payload.toastLabel') || get(action, 'meta.payload.toastLabel')
        ),
      };

    case 'PICK_YOUR_ROOM_AGENCY':
      return {
        className: 'mt-navigation',
        color: COLORS.BLUE_WAVE,
        icon: ICONS.CROSS_OUTLINE,
        label: get(action, 'payload.toastLabel') || get(action, 'meta.payload.toastLabel') || '',
        shouldDisplay: !!get(action, 'payload.toastLabel'),
      };

    case 'PAYMENT_BUTTON_ERROR':
    case ADD_ACCOMMODATION_ERROR:
      return {
        className: 'mt-navigation',
        color: COLORS.RED,
        icon: ICONS.CROSS_OUTLINE,
        label: action.payload.toastLabel,
        shouldDisplay: !!action.payload.toastLabel,
      };

    case UPDATE_SERVICES:
    case DELETE_SERVICE:
      return { ...state, className: 'mt-navigation', shouldDisplay: false };

    case CLOSE_TOAST:
    case FETCH_ADDITIONAL_ACCOMMODATIONS:
    case FETCH_ADDITIONAL_TRANSPORTS:
      return { ...state, className: 'mt-navigation', shouldDisplay: false };

    default:
      return state;
  }
};
